import * as React from 'react';
import { connect } from 'react-redux';
import { POLICY_DETAILS } from '../../routes/routes';
import ClaimProgressCard from './ClaimProgressCard';
import { navigateTo } from '../../actions/navigationActions';
import { showCallMeModal } from '../../actions/modalActions';
import { CLAIM_TYPE_GLASS, CLAIM_TYPE_NORMAL, CLAIM_TYPE_CELLPHONE, CLAIM_TYPE_WARRANTY, CLAIM_TYPE_VAP } from '../../constants/constants';

class ClaimProgress extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    handleCoverRedirect() {
        const isMobileWidth = window.innerWidth <= 975;
        if (isMobileWidth) {
            this.props.redirectTo(POLICY_DETAILS);
        }
    }

    handleClick() {}

    public render() {
        const { profile } = this.props;
        let claimCards = [];
        claimCards = this.props.claimSubmit.fnolStepConfiguration.steps.map((item) => {
            if ((item.maxSubSteps > 0) && ((this.props.claimSubmit.claimType === CLAIM_TYPE_NORMAL && item.title !== 'Complete') || (this.props.claimSubmit.claimType === CLAIM_TYPE_GLASS || this.props.claimSubmit.claimType === CLAIM_TYPE_CELLPHONE || this.props.claimSubmit.claimType === CLAIM_TYPE_WARRANTY || this.props.claimSubmit.claimType === CLAIM_TYPE_VAP || this.props.claimSubmit.followUp)) )
            {
                return <ClaimProgressCard id={(item.step === 1 && !this.props.claimSubmit.followUp) ? 4 : item.step} title={item.title} subTitle={item.subTitle} nr={item.step} isSelected={this.props.claimSubmit.selectedClaimStep.step === item.step} done={this.props.claimSubmit.selectedClaimStep.step > item.step || this.props.claimSubmit.selectedClaimStep.title === 'Complete'} stepLabel={item.stepLabel} />
            }
        });
        return (
            <div className="col fnol-claim-progress-col">
                <div className="fnol-claims-progress-block">
                    <h3>Progress</h3>
                </div>
                {claimCards}
             </div>
        );
    }
}


const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        //dispatchHideProfile: () => dispatch(hideMobileProfile()),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimProgress);